import { OpenFeature } from '@openfeature/web-sdk'
import debug from '../console'
import type { UserEngagement } from '../../store/userData/UserEngagementStore'

const logger = debug.withTag('updateUserEngagementState')

export const updateUserEngagementState = (state: UserEngagement) => {
  const reportingValue = state.isEngaged ? 'isEngaged' : 'notEngaged'

  const currentContext = OpenFeature.getContext()
  logger.info(`User engagement state updated: ${reportingValue}`)

  OpenFeature.setContext({
    ...currentContext,
    ...state,
  })

  window.assertiveQueue = window.assertiveQueue || []
  window.assertiveQueue.push(function () {
    if (window.assertive?.analytics?.custom) {
      window.assertive.analytics.custom.userState = reportingValue
    }
  })

  //page level targeting with split test name
  window.googletag = window.googletag || { cmd: [] }
  window.googletag.cmd.push(() => {
    window.googletag.setConfig({
      targeting: {
        user_engagement: reportingValue,
      },
    })
  })
}
